// Shared job data. Replace with your API/CMS later. `slug` drives the /careers/:slug route.
export const IMG = {
  team: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=900&q=80',
  work: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&w=900&q=80',
  talk: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=900&q=80',
  office: 'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80',
  meeting: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1000&q=80',
};

export const jobs = [
  {
    slug: 'branch-operations-manager-meridian-bank',
    client: 'Meridian Bank',
    title: 'Branch Operations Manager',
    location: 'Ikeja, Lagos',
    arrangement: 'On-site',
    type: 'Full-time',
    posted: '2026-10-14',
    short: 'Lead daily operations for a high-volume branch, from service quality to compliance and team performance.',
    about: 'Meridian Bank is expanding its branch network across four states and needs an operations lead who keeps every branch running smoothly, compliantly and with customers at the centre.',
    responsibilities: ['Oversee daily branch operations and service delivery', 'Coach and manage a team of 12 to 18 staff', 'Keep the branch within regulatory and audit requirements', 'Report weekly on targets, queues and customer feedback'],
    requirements: ['Bachelor’s degree in business, finance or a related field', '5+ years in banking operations, 2+ in a supervisory role', 'Working knowledge of CBN compliance requirements'],
    skills: ['People leadership', 'Process discipline', 'Clear written reporting', 'Calm under pressure'],
    offers: ['Competitive salary with performance bonus', 'HMO for you and your family', 'Structured path to regional management'],
  },
  {
    slug: 'sales-team-lead-kolade-foods',
    client: 'Kolade Foods',
    title: 'Sales Team Lead, Modern Trade',
    location: 'Lekki, Lagos',
    arrangement: 'Hybrid',
    type: 'Full-time',
    posted: '2026-10-12',
    short: 'Own the supermarket and retail chain accounts for a fast-growing FMCG brand.',
    about: 'Kolade Foods is scaling its presence in modern trade. You will run a field team, manage key accounts and turn weekly numbers into growth.',
    responsibilities: ['Manage relationships with major supermarket chains', 'Set weekly targets and review field performance', 'Plan promotions and in-store visibility with the marketing team', 'Forecast demand with supply planning'],
    requirements: ['4+ years in FMCG sales, with modern trade exposure', 'Track record of hitting or beating targets', 'Comfortable with Excel and CRM reporting'],
    skills: ['Negotiation', 'Account planning', 'Field coaching', 'Data-led decisions'],
    offers: ['Base pay plus uncapped commission', 'Company vehicle allowance', 'Quarterly leadership training'],
  },
  {
    slug: 'project-coordinator-atlas-logistics',
    client: 'Atlas Logistics',
    title: 'Project Coordinator',
    location: 'Apapa, Lagos',
    arrangement: 'On-site',
    type: 'Contract',
    posted: '2026-10-09',
    short: 'Keep a terminal upgrade on schedule by coordinating vendors, timelines and risks.',
    about: 'Atlas Logistics is running a 12-month terminal upgrade and needs a coordinator who keeps vendors, schedules and budgets visible to everyone.',
    responsibilities: ['Maintain the master project schedule and RAID log', 'Coordinate vendors and site teams day to day', 'Prepare weekly status reports for leadership', 'Flag slippage early with proposed fixes'],
    requirements: ['3+ years coordinating projects in logistics, construction or energy', 'PMP, PRINCE2 or equivalent is a plus', 'Strong MS Project or similar tool skills'],
    skills: ['Scheduling', 'Vendor management', 'Risk tracking', 'Stakeholder updates'],
    offers: ['12-month contract with extension option', 'Transport support', 'Exposure to a flagship infrastructure project'],
  },
  {
    slug: 'hr-business-partner-brightwell-health',
    client: 'Brightwell Health',
    title: 'HR Business Partner',
    location: 'Remote, Nigeria',
    arrangement: 'Remote',
    type: 'Full-time',
    posted: '2026-10-05',
    short: 'Partner with clinic leaders on hiring, performance and people policy across three sites.',
    about: 'Brightwell Health is growing its clinical and admin teams and needs an HR partner who can build people practices that hold up as it scales.',
    responsibilities: ['Advise managers on hiring, performance and conduct', 'Run end-to-end recruitment for clinical and admin roles', 'Maintain HR policies and statutory compliance', 'Lead onboarding and retention initiatives'],
    requirements: ['4+ years in HR generalist or business partner roles', 'CIPM or equivalent certification preferred', 'Experience with Nigerian labour law and payroll'],
    skills: ['Employee relations', 'Talent acquisition', 'Policy writing', 'Coaching managers'],
    offers: ['Fully remote with quarterly team days', 'Learning budget', 'Health cover'],
  },
  {
    slug: 'business-development-executive-pelican-telecoms',
    client: 'Pelican Telecoms',
    title: 'Business Development Executive',
    location: 'Victoria Island, Lagos',
    arrangement: 'Hybrid',
    type: 'Full-time',
    posted: '2026-09-30',
    short: 'Open new enterprise accounts and build a pipeline for connectivity and managed services.',
    about: 'Pelican Telecoms is pushing into the enterprise segment and wants a hunter who can open doors and close deals with mid-size and large businesses.',
    responsibilities: ['Identify and qualify enterprise prospects', 'Run discovery calls and tailored proposals', 'Maintain a clean pipeline in the CRM', 'Work with engineers on scoping solutions'],
    requirements: ['3+ years in B2B sales, telecoms or IT preferred', 'Proven record of closing enterprise deals', 'Excellent presentation skills'],
    skills: ['Prospecting', 'Consultative selling', 'Proposal writing', 'CRM discipline'],
    offers: ['Competitive base plus commission', 'Phone and data allowance', 'Clear route to senior sales roles'],
  },
];

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });